<template>
  <div class="solution1">
    <div class="x-top">
      <guide :guide="guide"></guide>
    </div>
    <div class="x-container">
      <div class="news-container">
        <p class="title">{{title}}</p>
        <!--<p>-->
          <!--<img :src="img" class="img" alt="">-->
        <!--</p>-->
        <div class="news-detail-container" style="text-align: left;" v-html="content"></div>
      </div>
      <div style="text-align: center">
        <span class="x-btn" @click="goback">返回</span>
      </div>
    </div>
  </div>
</template>

<script>
  import guide from '@/components/guide'
  import {getNewsById} from '@/api/download'
  import {addIpPrefixToImageSrc} from "../../../utils/elTipTapFunction";
  export default {
    name: "newsDetail",
    components: {
      guide,
    },
    data() {
      return {
        guide: [
          // {label: '格力智能楼宇'},
          {label: '关于我们'},
          {label: '产品&工程'},
          {label: '新闻详情'},
        ],
        content:'',
        img:'',
        title:''
      }
    },
    methods: {
      getNewsById(id){
        getNewsById(id).then(res=>{
          if(res.returnCode==='100'){
            this.title = res.returnData.title;
            this.img = this.$commonPicUrl + res.returnData.imageUrl;
            this.content = addIpPrefixToImageSrc(res.returnData.content, this.$commonPicUrl);
          }
        })
      },
      goback(){
        this.$router.push('/about/newsCenter')
      }
    },
    beforeRouteEnter(to, from, next){
      next(vm=>{
        vm.getNewsById(to.params.id);
      })
    },
    beforeRouteUpdate (to, from, next) {
      // just use `this`
      // this.name = to.params.id;
      this.getNewsById(to.params.id)
      next()
    }
  }
</script>

<style scoped lang="less">
  .x-top {
    min-height: 23rem;
    .x-top-img {
      text-align: right;
      img {
        width: 20rem;
      }
    }
  }

  .x-container {
    /*新闻列表*/
    .news-container {
      margin: auto;
      margin-bottom: 3rem;
      padding: 1rem;
      min-height: 30rem;
      background: transparent;
      /*box-shadow: 0 0 5px rgba(0, 0, 0, 0.3);*/
      /*border-radius: 15px;*/
      .title {
        font-size: 1.1rem;
        padding: 1rem;
        color: @deepblue;
      }
      .img{
        width: 100%;
        margin-bottom: 20px;
      }
    }
    .x-btn {
      text-align: center;
      display: inline-block;
      color: #fff;
      background-image: linear-gradient(to right, rgb(112, 68, 249), rgb(84, 106, 238));
      width: 4rem;
      border-radius: 50px;
      padding: 0.5rem 2rem 0.5rem 2rem;
      cursor: pointer;
    }
  }
</style>
<style lang="less" scoped>
  @media only screen and (min-width: 320px) {
    .x-top {
      background: url("../../../assets/img/mobile/about/about3/background.png") !important;
      background-repeat: no-repeat !important;
      background-size: cover !important;
      background-position: center center !important;
      box-sizing: border-box !important;
    }

  }

  @media only screen and (min-width: 768px) {
    .x-top {
      background: url("../../../assets/img/pc/about/about3/background.png") !important;
      background-repeat: no-repeat !important;
      background-size: cover !important;
      background-position: center center !important;
      box-sizing: border-box !important;
    }
    .x-container {
      /*新闻列表*/
      .news-container {
        width: 80%;
        .img{
          width: 80%;
        }
      }
    }
  }
</style>
<style>
  .news-detail-container img{
    max-width: 100%;
  }
</style>
